<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				日志列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{total}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<div style="padding: 20px 20px 0px 20px;">
				<el-table :data="list" stripe
					style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;" size="small"
					:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}" :row-style="{border_color:'rgb(75, 83, 87)'}"
					height="600" v-loading="loading">
					<el-table-column label="操作类型"  align="left" width="130" show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.type}}
						</template>
					</el-table-column>
					<el-table-column label="时间" width="150" align="left">
						<template slot-scope="scope">
							{{scope.row.time|formatTime}}
						</template>
					</el-table-column>
					<el-table-column label="详情"  align="left" show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.info}}
						</template>
					</el-table-column>
				</el-table>
				<div class="footer" style="margin-top: 15px;">
					<el-pagination layout="total, prev, pager, next,sizes" @current-change="toPage" :total="total"
						:page-sizes="[10,25,50,100]" :current-page="form.page" :page-size="form.limit"  @size-change="handleSizeChange">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				cards: '',
				loading: false,
				days: 0,
				limit: 15,
				total: 0,
				form: {
					page:1,
					limit:10
				},
				page:1,
				total:0,
				software_list: [],
				now_timestamp: 0,
				list: [],
			}
		},
		created() {
			this.getData()
		},
		computed: {
			...mapState({
				user: state => state.user,
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.getData()
			}
		},
		filters:{
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			},
		},
		methods: {
			toPage(e){
				this.form.page = e
				this.getData()
			},
			handleSizeChange(e){
				this.form.limit = e
				this.form.page = 1
				this.getData()
			},
			confromCard() {
				this.dialogOptions = true
			},
			toEdit(agent_software_id) {
				this.$emit('toEdit', agent_software_id)

			},
			getData() {
				this.loading = true
				this.$H.post('/verify_center/v1_0_1.Center/Log', this.form).then(res => {
					this.loading = false
					if (res.data) {
						console.log(res.data)
						if (this.form.page === 1) {
							this.total = res.data.total
						}
						this.list = res.data.data
					}
				}).catch(err => {
					this.loading = false
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>